import {toNum} from "../app/utils";
import {LOCAL_STORAGE_USER_ID_KEY, LOCAL_STORAGE_USERNAME_KEY} from "./auth";

export function getCurrentUserId(): number {
    return toNum(localStorage.getItem(LOCAL_STORAGE_USER_ID_KEY));
}

export function getCurrentUsername(): string | null {
    return localStorage.getItem(LOCAL_STORAGE_USERNAME_KEY);
}